<template>
    <v-card>
        <v-card-title class="bg-title-card">
            <span class="white--text headline">Sucursal Aseguradora</span>
        </v-card-title>
        <v-container grid-list-md>
            <v-form ref="form">
                <v-container grid-list-md text-xs-center>
                    <v-row dense>
                        <v-col cols="12" sm="4">
                            <v-text-field label="Nombre Sucursal *" color="textbox" v-model="seleccionado.sucursal"
                                :rules="_.concat(requeridoRegla,letrasRegla)" :counter="300" outlined dense />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-autocomplete label="Aseguradora *" color="textbox" v-model="seleccionado.idAseguradora"
                                :rules="requeridoRegla" :items="listaGeneral.aseguradora" item-text="aseguradora"
                                item-value="idAseguradora" outlined dense />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-autocomplete label="Estado *" color="textbox" v-model="seleccionado.idEstado"
                                :rules="requeridoRegla" :items="listaEstadoModal" item-text="nombre_estado"
                                item-value="id_estado" outlined dense />
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" sm="6">
                            <v-autocomplete label="Provincia *" color="textbox" v-model="seleccionado.idProvincia"
                                :rules="requeridoRegla" :items="listaGeneral.provincia" item-text="text"
                                item-value="value" @change="seleccionado.idCanton = null, listarCanton('modal')"
                                outlined dense />
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-autocomplete label="Cantón *" color="textbox" v-model="seleccionado.idCanton"
                                :rules="requeridoRegla" :items="listaCanton" item-text="canton" item-value="idCanton"
                                outlined dense />
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" sm="6">
                            <v-text-field label="Teléfono Celular *" color="textbox"
                                v-model="seleccionado.telefonoCelular"
                                :rules="_.concat(requeridoRegla,soloNumerosRegla(10,seleccionado.telefonoCelular,10))"
                                :counter="100" mask="### ### ####" outlined dense />
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field label="Teléfono Convencional *" color="textbox"
                                v-model="seleccionado.telefonoPBX"
                                :rules="_.concat(requeridoRegla,soloNumerosRegla(9,seleccionado.telefonoPBX,9))"
                                :counter="100" :mask="'(###) ### ###'" outlined dense />
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-spacer></v-spacer>
                        <v-col class="text-right">
                            <v-btn outlined dense rounded color="danger" class="mr-1"
                                @click="cerrarFormulario(), $refs.form.resetValidation()">Cancelar</v-btn>
                            <v-btn rounded dark color="primary" @click="guardar()">Guardar</v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-form>
        </v-container>
    </v-card>
</template>

<script>
    export default {
        props: ['seleccionado', 'tituloFormulario', 'listaGeneral', 'listaCanton'],
        inject: ['insertarActualizar', 'listarCanton', 'cerrarFormulario'],
        methods: {
            guardar() {
                if (this.$refs.form.validate()) {
                    this.insertarActualizar((this.seleccionado.idSucursal == null) ? "I" : 'U');
                    this.$refs.form.resetValidation();
                    this.cerrarFormulario();
                } else
                    mensajesAlerta(mensajeEstandar.corregirInformacion, 'I');
            }
        },
        computed: {
            listaEstadoModal() {
                var listadoEstadoModal = this.listaGeneral.estado;
                if (this.listaGeneral.estado) {
                    listadoEstadoModal = this.listaGeneral.estado.filter(estado => {
                        return estado.visualiza.toLowerCase().includes('true');
                    });
                    this.seleccionado.idEstado = (this.seleccionado.idSucursal == null) ? '1' : this.seleccionado
                        .idEstado;
                    //if(this.seleccionado.idProvincia) this.listarCanton("modal");
                }
                return listadoEstadoModal;
            },
        },
    }
</script>